var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.boolean)?_c('v-chip',{class:`font-weight-bold ${_vm.margin}`,attrs:{"color":"primary","text-color":"white","small":""}},[_vm._v(" "+_vm._s(_vm.text)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }